module.exports = __webpack_public_path__ + "static/alena-f42751c3a17ed5d24d3001fba8c5f876.jpg";